export function asciidoctorConvertWithOptions(text){
    return asciidoctor().convert(text, asciidocOptions)
}

/**
 * We set the experimental attribute in the convert options to enable some macros from asciidoc
 * For example Keyboard macro, Menu macro
 */
const asciidocOptions = {
    attributes: {
        'experimental': '',
    }
}